package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.OnboardingTitleText

@Composable
internal fun ClientAuthBackHeader(
    onBackClick: () -> Unit,
    title: String? = null,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(44.dp)
    ) {
        IconButton(
            onClick = onBackClick,
            modifier = Modifier
                .align(Alignment.CenterStart)
                .size(44.dp)
        ) {
            Icon(
                painter = AppIcons.ArrowLeft,
                contentDescription = null,
                tint = MineShaft950,
                modifier = Modifier.size(24.dp)
            )
        }

        if (title != null) {
            Text(
                text = title,
                style = OnboardingTitleText,
                textAlign = TextAlign.Center,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .align(Alignment.Center)
                    .fillMaxWidth()
                    .padding(horizontal = 52.dp)
            )
        }
    }
}
